import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

export interface ImageViewerData {
  textureLink: string;
  plugLink?: string;
}

@Component({
  selector: 'csl-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ImageViewerComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ImageViewerData) {}

  ngOnInit(): void {}

  setImagePlug(e: Event): void {
    (e.target as HTMLImageElement).src = this.data.plugLink;
  }
}
